import { types } from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const getStagesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SEND_REQUEST_GET_STAGES:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_GET_STAGES_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_GET_STAGES_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
    case types.CLEAR_REQUEST_GET_STAGES:
      return {
        ...state,
        data: {},
        loading: false,
      };
    default:
      return state;
  }
};

export default getStagesReducer;
